"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EllipsisOutline = {
  name: 'ellipsis',
  theme: 'outline',
  nameWithTheme: 'ellipsis-o',
  tag: 'svg',
  attrs: {
    xmlns: 'http://www.w3.org/2000/svg',
    class: 'icon',
    viewBox: '0 0 1024 1024'
  },
  children: [{
    tag: 'path',
    attrs: {
      d: 'M176 511a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm280 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm280 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'
    },
    children: []
  }]
};
exports.default = EllipsisOutline;